const medicineBazarAf = {
  search: {
    placeholders: [
      'د درمل نوم ولیکئ...',
      'د جنریک نوم ولیکئ...',
      'د شرکت نوم ولیکئ...',
      'د برانډ نوم ولیکئ...',
      'د پلورنځي نوم ولیکئ...'
    ]
  },
  sidebar: {
    categoriesTitle: 'کټګورۍ',
    storesTitle: 'پلورنځي'
  },
  upload: {
    title: 'نسخه اپلوډ کړئ',
    subtitle: 'د خپل ډاکتر نسخه اپلوډ کړئ او په اسانۍ سره درمل امر کړئ',
    uploadedPrefix: '✓ فایل اپلوډ شوی:',
    chooseFile: 'فایل وټاکئ',
    replaceFile: 'نوی فایل اپلوډ کړئ'
  },
  store: {
    serviceAreaLabel: 'د خدمت سیمه',
    nationwide: 'ټوله هیواده',
    medicineCountLabel: 'درمل',
    close: 'تړل',
    productsOfSuffix: 'درمل',
    descriptionPrefix: 'لاندې د',
    descriptionSuffix: 'د درملخانې ټول شتون لرونکي درمل دي. تاسو کولی شئ د کټګورۍ له مخې فلټر کړئ.'
  },
  card: {
    addToCart: 'په کڅوړه کې اضافه کړئ'
  },
  empty: {
    title: 'هیڅ درمل و نه موندل شول',
    subtitle: 'مهرباني وکړئ بل کټګوري یا درملخانې وټاکئ'
  },
  prescriptionFlow: {
    successTitle: 'نسخه په بریالیتوب سره اپلوډ شوه!',
    instruction: 'مهرباني وکړئ د خپل د درمل امر د سپارلو لپاره لاندې تفصیلات ډکه کړئ',
    step1: {
      title: 'یوه درملخانه وټاکئ',
      subtitle: 'تاسو له کومې درملخانې څخه پلورل غواړئ؟',
      next: 'راتلونکی'
    },
    step2: {
      title: 'د کورس موده وټاکئ',
      subtitle: 'تاسو د څو ورځو لپاره درمل غواړئ؟',
      fullCourse: 'بشپړ کورس',
      fiveDays: '5 ورځې',
      tenDays: '10 ورځې',
      customDays: 'دودیز ورځې',
      customDaysLabel: 'څو ورځې؟',
      customDaysPlaceholder: 'لکه: 15',
      back: 'شاته',
      next: 'راتلونکی'
    },
    step3: {
      title: 'امر تایید کړئ',
      summaryTitle: 'ستاسو د امر لنډیز:',
      pharmacyLabel: 'درملخانه',
      durationLabel: 'د کورس موده',
      prescriptionLabel: 'نسخه',
      back: 'شاته',
      confirm: 'امر تایید کړئ'
    },
    snackbar: {
      successTitle: '🎉 امر په بریالیتوب سره سپارل شو!',
      message: 'ستاسو ټاکل شوې درملخانه به ژر تاسو سره د قیمت او تفصیلاتو سره اړیکه ونیسي.'
    }
  }
};

export default medicineBazarAf;
